import EditIcon from '@mui/icons-material/Edit';
import EmailIcon from '@mui/icons-material/Email';
import BiometricIcon from '@mui/icons-material/Fingerprint';
import { useTranslation } from 'react-i18next';
import { Action } from "../../types/toolbar";
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { useState } from "react";
import CustomModal from "../../components/ui/modal/modal.component";
import { EditProfile } from '../../workspaces/profile/editProfile/editProfile.component';
import { ChangeEmailProfile } from '../../workspaces/profile/changeEmail/changeEmailProfile.component';
import { ManagePasskeys } from '../../workspaces/profile/managePasskeys/managePasskeys.component';

export const ProfileActions = () => {
  const { t } = useTranslation();
  const [editProfileOpened, setEditProfileOpened] = useState<boolean>(false);
  const [changeEmailOpened, setChangeEmailOpened] = useState<boolean>(false);
  const [managePasskeysOpened, setManagePasskeysOpened] = useState<boolean>(false);

  const actions: Action[] = [
    {
      icon: <EditIcon />,
      label: t("Edit profile"),
      onClick: () => { setEditProfileOpened(true) },
    },
    {
      icon: <EmailIcon />,
      label: t("Change email"),
      onClick: () => { setChangeEmailOpened(true) },
    },
    {
      icon: <BiometricIcon />,
      label: t("Biometric login"),
      onClick: () => { setManagePasskeysOpened(true) },
    },
  ];

  return (
    <>
      <Toolbar actions={actions} />
      <CustomModal
        opened={editProfileOpened}
        setOpened={setEditProfileOpened}
        title={t("Edit profile")}
        content={<EditProfile onSuccess={() => setEditProfileOpened(false)} />}
      />
      <CustomModal opened={changeEmailOpened} setOpened={setChangeEmailOpened} title={t("Change email")} content={<ChangeEmailProfile onSuccess={() => setChangeEmailOpened(false)} />} />
      <CustomModal opened={managePasskeysOpened} setOpened={setManagePasskeysOpened} title={t("Biometric login")} content={<ManagePasskeys />} />
    </>
  );
};
